import React from 'react';
import { DragSource } from 'react-dnd';
import { FormattedMessage } from 'react-intl';
import useUser from 'hooks/useUser';
import ContentTypeIcon from 'components/ContentTypeIcon';
import { QUESTION_TYPES, CONTENT_TYPES, DEFAULT_OPTIONS } from 'shared/constants/survey';
import { SUPER_USER } from 'shared/constants/permissions';

import messages from './messages';
import './drag-to-add.less';

export const NODE_DND_TYPE = 'SurveyContent';

const dragSourceSpec = {
  beginDrag: (item) => {
    if (item.type === CONTENT_TYPES.BLOCK) {
      return {
        node: { active: true, block: { title: '' }, children: [] },
      };
    }
    if (item.type === CONTENT_TYPES.TEXT) {
      return {
        node: { active: true, text: { body: '' } },
      };
    }
    if (item.type === CONTENT_TYPES.PAGE_BREAK) {
      return {
        node: { pageBreak: true },
      };
    }
    return {
      node: {
        active: true,
        question: {
          settings: { type: item.type },
          categories: item.categories,
          options: item.options,
        },
      },
    };
  },
};

const collect = connect => ({ connectDragSource: connect.dragSource() });

const DraggableItem = ({ connectDragSource, title, type }) => {
  const item = (
    <div className="drag__item">
      <ContentTypeIcon type={type} />
      <span className="drag__item-title">{title}</span>
    </div>
  );
  return connectDragSource(item, { dropEffect: 'copy' });
};

const Item = DragSource(NODE_DND_TYPE, dragSourceSpec, collect)(DraggableItem);

const DragToAddContent = () => {
  const { hasPermission } = useUser();

  return (
    <>
      <div className="drag__section">
        <div className="drag__section-title"><FormattedMessage {...messages.structure} /></div>
        <Item title={<FormattedMessage {...messages.block} />} type={CONTENT_TYPES.BLOCK} />
        <Item title={<FormattedMessage {...messages.pageBreak} />} type={CONTENT_TYPES.PAGE_BREAK} />
        <Item title={<FormattedMessage {...messages.text} />} type={CONTENT_TYPES.TEXT} />
      </div>
      <div className="drag__section">
        <div className="drag__section-title">Custom</div>
        <Item title={<FormattedMessage {...messages.radio} />} type={QUESTION_TYPES.RADIO} />
        <Item title={<FormattedMessage {...messages.checkbox} />} type={QUESTION_TYPES.CHECKBOX} />
        <Item title={<FormattedMessage {...messages.field} />} type={QUESTION_TYPES.FIELD} />
        <Item title={<FormattedMessage {...messages.sentiment} />} type={QUESTION_TYPES.SENTIMENT} />
        <Item title={<FormattedMessage {...messages.thumbs} />} type={QUESTION_TYPES.THUMBS} />
        <Item title={<FormattedMessage {...messages.grade} />} type={QUESTION_TYPES.GRADE} options={DEFAULT_OPTIONS[QUESTION_TYPES.GRADE]} />
        <Item title={<FormattedMessage {...messages.nps} />} type={QUESTION_TYPES.NPS} options={DEFAULT_OPTIONS[QUESTION_TYPES.NPS]} />
        <Item title={<FormattedMessage {...messages.contact} />} type={QUESTION_TYPES.CONTACT} />
      </div>
      {hasPermission(SUPER_USER) && (
        <div className="drag__section">
          <div className="drag__section-title">Special</div>
          <Item title={<FormattedMessage {...messages.zip} />} type={QUESTION_TYPES.ZIP} />
          <Item title={<FormattedMessage {...messages.country} />} type={QUESTION_TYPES.COUNTRY} />
        </div>
      )}
    </>
  );
};

export default DragToAddContent;
